import React from 'react'
import SocialMedia from '../layout/Navbar/SocialMedia'
import NavigationDots from '../layout/Navbar/NavigationDots'

const wrapper = (Component, idName, classesName, darkToggle) => () => {
  return (
    <section id={idName} className={`app__container ${classesName}`}>
      <SocialMedia />

      <div className='app__wrapper app__flex'>
        <Component darkToggle={darkToggle} />

        {/* <div className='copyright'>
          <p className='p-text'>@2022 Taha_Ebaed</p>
          <p className='p-text'>All Right reserved</p>
        </div> */}
      </div>

      <NavigationDots active={idName} />
    </section>
  )
}

export default wrapper
